import VerifyCodeProvider from '../providers/verify-code-provider';

class VerifyCodeRepository {

    constructor() {
        this.verifyCodeProvider = new VerifyCodeProvider();
    }

    verificarCodigo = async (datosVerificacion) => {
        return this.verifyCodeProvider.verificarCodigo(datosVerificacion);
    }

}

export default VerifyCodeRepository;